import { render, staticRenderFns } from "./QCBatchList.vue?vue&type=template&id=52fd433c&scoped=true&"
import script from "./QCBatchList.vue?vue&type=script&lang=js&"
export * from "./QCBatchList.vue?vue&type=script&lang=js&"
import style0 from "./QCBatchList.vue?vue&type=style&index=0&id=52fd433c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fd433c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VContainer,
  VLayout,
})
